<template>
  <div class="cover" :style="{minHeight: clientHeight}">
    <nav-header style="display: none" v-bind:showSearch="p_showSearch" v-bind:loginModalFlag="p_loginModalFlag" v-on:showLoginModal="p_showLoginModal" v-on:closeLoginModal="p_closeLoginModal"></nav-header>
    <div class="container">
      <el-form ref="applyForm" :model="form" size="small" :rules="formRule">
        <el-form-item prop="companyName">
          <label><span>*</span>单位名称</label>
          <div>
            <el-input v-model="form.companyName"></el-input>
          </div>
        </el-form-item>

        <el-form-item prop="address">
          <label>地址</label>
          <div>
            <el-input v-model="form.address"></el-input>
          </div>
        </el-form-item>

        <el-form-item prop="name">
          <label><span>*</span>联系人</label>
          <div>
            <el-input v-model="form.name"></el-input>
          </div>
        </el-form-item>

        <el-form-item prop="mobile">
          <label><span>*</span>联系电话</label>
          <div>
            <el-input v-model="form.mobile"></el-input>
          </div>
        </el-form-item>

        <el-form-item prop="position">
          <label>职位</label>
          <div>
            <el-input v-model="form.position"></el-input>
          </div>
        </el-form-item>

        <el-form-item prop="num">
          <label><span>*</span>检测人数</label>
          <div>
            <el-input v-model="form.num"></el-input>
          </div>
        </el-form-item>

        <el-form-item prop="remark">
          <label>备注</label>
          <div>
            <el-input v-model="form.remark"></el-input>
          </div>
        </el-form-item>

        <!--          <el-form-item prop="medicalLicense">-->
        <!--            <label><span>*</span>医疗机构执业许可证</label>-->
        <!--            <div>-->
        <!--              <el-upload class="upload"-->
        <!--                 action="https://xcx.liferiverdx.com/hpv/upload/unlogin"-->
        <!--                 :show-file-list="false"-->
        <!--                 :before-upload="() => uploadLoading = 'medicalLicense'"-->
        <!--                 :on-success="(resp, file) => uploadChange(resp, file, 'medicalLicense')"-->
        <!--                 :on-error="(resp, file) => uploadChange(resp, file, 'medicalLicense')">-->
        <!--                <el-input :disabled="true" :prefix-icon="uploadIcon('medicalLicense')" placeholder="上传文件" v-model="form.medicalLicense_label"></el-input>-->
        <!--              </el-upload>-->
        <!--            </div>-->
        <!--          </el-form-item>-->

        <!--          <el-form-item prop="powerOfAttorney">-->
        <!--            <label><span>*</span>医疗机构授权同意书</label>-->
        <!--            <div>-->
        <!--              <el-upload class="upload"-->
        <!--                 action="https://xcx.liferiverdx.com/hpv/upload/unlogin"-->
        <!--                 :show-file-list="false"-->
        <!--                 :before-upload="() => uploadLoading = 'powerOfAttorney'"-->
        <!--                 :on-success="(resp, file) => uploadChange(resp, file, 'powerOfAttorney')"-->
        <!--                 :on-error="(resp, file) => uploadChange(resp, file, 'powerOfAttorney')">-->
        <!--                <el-input :disabled="true" :prefix-icon="uploadIcon('powerOfAttorney')" placeholder="上传文件" v-model="form.powerOfAttorney_label" clearable></el-input>-->
        <!--              </el-upload>-->
        <!--            </div>-->
        <!--          </el-form-item>-->

        <el-form-item class="submit">
          <el-button class="submit_btn" type="primary" @click="submit" :disabled="uploadLoading">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>

</template>

<script>
  import axios from 'axios'
  import NavHeader from "@/components/Header.vue";
  import {getCookie, removeHTMLTag} from "../../util/util"
  import 'babel-polyfill'

  export default {
    name: "NovelCoronavirusApply",
    data() {
      return {
        clientHeight: 0,
        uploadLoading: null,
        form: {},
        p_showSearch: true,
        p_loginModalFlag: false,
        formRule: {
          companyName: [
            { required: true, trigger: 'blur', message: '请填写单位名称'},
            { max: 50, message: '长度不能超过50个字符' }
          ],
          address: [
            { max: 100, message: '长度不能超过100个字符' }
          ],
          name: [
            { required: true, trigger: 'blur', message: '请填写联系人'},
            { max: 15, message: '长度不能超过15个字符' }
          ],
          mobile: [
            { required: true, trigger: 'blur', message: '请填写手机号'},
            { pattern: /^\d{11}$/, message: '请填写正确手机号', trigger: 'blur' }
          ],
          position: [
            { max: 15, message: '长度不能超过15个字符' }
          ],
          remark: [
            { max: 100, message: '长度不能超过100个字符' }
          ],
          num: [
            { required: true, trigger: 'blur', message: '请填写检测人数'},
            { pattern: /^[1-9]\d*$/, message: '请填写整数', trigger: 'blur' },
            { max: 6, message: '长度不能超过6个字符' }
          ]
          // medicalLicense: [ { required: true, trigger: 'blur', message: '请上传医疗机构执业许可证'} ],
          // powerOfAttorney: [ { required: true, trigger: 'blur', message: '请上传医疗机构授权同意书'} ],
        }
      };
    },
    components: {
      NavHeader
    },
    computed: {
      token (){
        return getCookie("_token")?getCookie("_token"):""
      },
      user () {
        return this.$store.state.user
      },
      uploadIcon () {
        return function (id) {
          return this.uploadLoading && this.uploadLoading === id ? 'el-icon-loading' : 'el-icon-upload2'
        }
      }
    },
    mounted(){
      setTimeout(() => {
        this.clientHeight = document.documentElement.clientHeight + 'px'
      }, 100)
      this.$set(this.form, 'mobile', this.user.mobile)
    },
    methods: {
      p_showLoginModal () {
        this.p_loginModalFlag = true;
      },

      p_closeLoginModal () {
        this.p_loginModalFlag = false;
      },

      doOrder () {
        this.$message('正在研发中');
      },

      uploadChange (resp, file, key) {
        let { msg, code, type } = resp
        if (msg === 'success' && code === 0) {
          this.$message.success('上传成功')
          this.$set(this.form, `${key}_label`, file.name)
          this.$set(this.form, key, resp.url)
        } else {
          this.$message.error('上传失败')
          this.$set(this.form, `${key}_label`, '')
          this.$set(this.form, key, '')
        }
        this.$refs.applyForm.validateField(key)
        this.uploadLoading = null
      },

      submit () {
        this.$refs.applyForm.validate((valid) => {
          if (valid) {
            this.uploadLoading = true
            axios.post(`/jys/questionnaire/saveRespiratoryTract`,
              this.form, {
                headers: {
                  "Content-Type": "application/json",
                  'token': getCookie("_token")
                }
              }
            ).then(({data}) => {
              this.uploadLoading = false
              if (data.code === 0) {
                this.$alert('您的申请已提交成功，我们审核通过后，会由专人与您联系，请保持电话畅通。', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$router.go(-1)
                    window.open("https://xcx.liferiverdx.com/service/images/huxidao.jpg")
                  }
                })
              }
            })
          }
        })
      }
    }
  };
</script>

<style scoped >
  .cover{
    width: 100%;
    float: left;
    background-color:#eef8fd;
  }
  .container {
    width: 80%;
    margin: 30px auto;
    color: #1158a9;
  }
  .el-form-item label > span {
    color: red;
    margin-right: 5px;
  }
  .el-form-item >>> .el-input--small .el-input__inner{
    border: none;
  }
  .submit{
    text-align: center;
    margin-top: 100px;
  }
  .submit_btn{
    width: 100%;
    color: #ffffff;
    background-color: #419bda;
    border-color: #419bda;
    border-radius: 20px;
  }
  /deep/ .upload .el-upload {display:block !important;}
  /deep/ .upload .is-disabled input {
    background:#fff !important;
    cursor: pointer !important;
    border-color: #ccc;color:#000
  }
  @media only screen and (min-width: 600px) {
    .container{
      width: 45%;
      margin-top: 70px;
    }
    .submit_btn{
      width: 50%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/activities/novel-coronavirus-apply.vue